import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const data = [
  { 'Concentration (mg/mL)': 0, 'Signal': 1000 },
  { 'Concentration (mg/mL)': 40, 'Signal': 100000 },
  { 'Concentration (mg/mL)': 95, 'Signal': 250000 },
  { 'Concentration (mg/mL)': 180, 'Signal': 450000 },
  { 'Concentration (mg/mL)': 330, 'Signal': 960000 },
];

function Figure2() {
  // Générer les valeurs de l'axe X avec des incréments égaux de 50
  

  return (
    <div>
      <br></br>
      <u>Figure 2: Fluorescence </u>
      <LineChart width={600} height={300} data={data} margin={{ top: 20, right: 30, left: 20, bottom: 10 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="Concentration (mg/mL)" type="number" scale="linear" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="Signal" stroke="blue" />
      </LineChart>
    </div>
  );
}

export default Figure2;
